import * as Yup from "yup";
import { ReferenceType } from "us.collection/layouts/CaseView/Constants";

export const ValidationSchema = Yup.object().shape({
  referenceType: Yup.string()
    .nullable()
    .required(
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD",
    ),
  referenceNo: Yup.string().required(
    "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD",
  ),
  nextFollowUpDate: Yup.string()
    .nullable()
    .when("referenceType", {
      is: (value: ReferenceType) => value === ReferenceType.DEBT_SETTLEMENT,
      then: Yup.string()
        .nullable()
        .required(
          "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD",
        ),
      otherwise: Yup.string().nullable().notRequired(),
    }),
});
